"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tridentSwapFeeAbi = void 0;
exports.tridentSwapFeeAbi = [
    {
        inputs: [],
        name: 'swapFee',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
//# sourceMappingURL=tridentSwapFeeAbi.js.map